
  


  export const  setOnlineUser=(a)=>{
       
    return{
        type:"SET_ONLINE_USER",
        value:a
    }
}